import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    justify-items: center;\n    align-items: center;\n    grid-gap: 20px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Code } from '../Code';
import { getChildrenByType } from '../Code/lib/getChildrenByType';
import { Swap } from '../Swap';
import { SubSteps } from '../SubSteps';
export const CodeWithText = props => {
  const infos = getChildrenByType('info', props.children);
  return React.createElement(SubSteps, {
    start: props.start,
    unwrap: props.unwrap
  }, React.createElement(Columns, null, React.createElement("div", null, React.createElement(Swap, {
    start: props.start,
    unwrap: true
  }, infos)), React.createElement("div", null, React.createElement(Code, Object.assign({}, props, {
    start: props.start,
    unwrap: true
  })))));
};
const Columns = styled.div(_templateObject());